import { api } from "@/lib/api";

export interface ServiceProviderInput {
  name: string;
}

export interface ServiceProviderOutput {
  id: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
}

export const serviceProviderService = {
  async getAllServiceProviders(): Promise<ServiceProviderOutput[]> {
    try {
      const response = await api.get("/serviceProvider");
      const data = Array.isArray(response.data)
        ? response.data
        : response.data.data || response.data;
      return data || [];
    } catch (error) {
      console.error("Error fetching service providers:", error);
      throw error;
    }
  },

  async createServiceProvider(
    payload: ServiceProviderInput
  ): Promise<ServiceProviderOutput> {
    try {
      const response = await api.post("/serviceProvider", payload);
      const created = Array.isArray(response.data)
        ? response.data[0]
        : response.data.data || response.data;
      return created;
    } catch (error) {
      console.error("Error creating service provider:", error);
      throw error;
    }
  },
};
